module.exports = __webpack_public_path__ + "fonts/windows_60x60.8b72c380b341bccc5dba9099948cc7ae.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/windows_60x60.png
// module id = 784
// module chunks = 9